import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   wrapper: {
      position: 'fixed',
      top: '20rem',
      right: '2rem',
      marginTop: '8px',
      height: 380
   },
   speedDial: {
      position: 'absolute',
      '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
         bottom: '16px',
         right: '16px'
      },
      '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
         top: '16px',
         left: '16px'
      }
   }
}));

/**
 * Boton de accion flotante capaz de mostrar hasta 6 botones desplegables relacionados.
 */
function SpeedDialDS(props) {
   const {hidden, icon, openIcon, direction, actions, ...others} = props;
   const {classes} = useStyles();
   const [open, setOpen] = useState(false);

   const handleOpen = () => {
      setOpen(true);
   };

   const handleClose = () => {
      setOpen(false);
   };

   return (
      <div>
         <SpeedDial
            {...others}
            ariaLabel="Speed Dial DS"
            className={classes.speedDial}
            hidden={hidden}
            icon={<SpeedDialIcon icon={icon} openIcon={openIcon} />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={direction}
         >
            {actions.map((action) => {
               return <SpeedDialAction key={action.name} tooltipTitle={action.name} {...action} />;
            })}
         </SpeedDial>
      </div>
   );
}

SpeedDialDS.propTypes = {
   /**
    * Si es true el SpeedDial no es visible.
    */
   hidden: PropTypes.bool,
   /**
    * Objeto a mostrar como icono del SpeedDial.
    */
   icon: PropTypes.node,
   /**
    * Objeto a mostrar como icon del SpeedDial cuando las acciones estan desplegadas.
    */
   openIcon: PropTypes.node,
   /**
    * Direccion hacia la cual se desplegaran las acciones.
    */
   direction: PropTypes.oneOf(['up', 'right', 'down', 'left']),
   /**
    * Arreglo de objetos con la informacion de cada accion del speed dial. Son obligatorios
    * el icono de la accion, el nombre que servira tambien como identificador y la accion a realizar al hacer click.
    * Otras propiedades que puede aceptar son las propiedades de SpeedDialAction de Material-UI: https://material-ui.com/api/speed-dial-action/
    */
   actions: PropTypes.arrayOf(
      PropTypes.shape({
         icon: PropTypes.node.isRequired,
         name: PropTypes.string.isRequired,
         onClick: PropTypes.func.isRequired
      })
   )
};

SpeedDialDS.defaultProps = {
   hidden: false,
   direction: 'up',
   actions: [
      {
         name: 'Muestra',
         icon: <ContactSupportIcon />,
         onClick: () => {
            window.alert('Soy la accion default!');
         }
      }
   ]
};

export default SpeedDialDS;
